/**
 * London neighbourhoods — fuente única (scrapedColivings: region=uk, isActive=true).
 * Last verified: 2026-07-02 — 537 listings, 78 distinct propertyLocation values.
 *
 * Consumido por:
 *   - frontend/src/components/ColivingAdvancedSearch.vue
 *   - frontend/src/components/schemas/ColivingSearchSchema.js
 *   - backend/src/searchProperties.ts
 *   - shared/locationRegistry.cjs (slugs UK)
 */

'use strict';

/** Todos los propertyLocation activos en Firestore, orden alfabético */
const LONDON_NEIGHBORHOODS = [
  'Acton',
  'Aldgate',
  'Bankside',
  'Battersea',
  'Belsize Park',
  'Bethnal Green',
  'Bloomsbury',
  'Bow',
  'Brondesbury',
  'Brixton',
  'Camden',
  'Canada Water',
  'Canary Wharf',
  'Canning Town',
  'Charlton',
  'Clapham',
  'Clapham Common',
  'Clapham Junction',
  'Clerkenwell',
  'Colindale',
  'Deptford',
  'Earls Court',
  'Earlsfield',
  'East Putney',
  'Ealing',
  'Elephant and Castle',
  'Epsom',
  'Finsbury Park',
  'Fulham',
  'Greenwich',
  'Hackney',
  'Hammersmith',
  'Harrow',
  'Hayes',
  'Highbury',
  'Holloway',
  'Hounslow',
  'Hoxton',
  'Islington',
  'Kentish Town',
  'Kings Cross',
  'Kingston',
  'Lewisham',
  'Limehouse',
  'London',
  'London Bridge',
  'Maida Vale',
  'Marylebone',
  'Mile End',
  'New Cross',
  'New Malden',
  'North Acton',
  'Notting Hill',
  'Poplar',
  'Portobello',
  'Primrose Hill',
  'Royal Docks',
  'Shoreditch',
  'South Bank',
  'South Bermondsey',
  'Southall',
  'Southwark',
  'Stepney Green',
  'Stockwell',
  'Stratford',
  'Tooting',
  'Tottenham',
  'Tufnell Park',
  'Vauxhall',
  'Walthamstow',
  'Wapping',
  'Wembley',
  'West Hampstead',
  'West Kensington',
  'Westbourne Park',
  'Westminster',
  'White City',
  'Whitechapel',
];

/** Chips rápidos — top inventario Firestore (jul 2026) + demanda GSC */
const QUICK_LONDON_AREAS = [
  { slug: 'shoreditch', label: 'Shoreditch' },           // 53 listings
  { slug: 'wembley', label: 'Wembley' },                 // 39
  { slug: 'islington', label: 'Islington' },             // 27
  { slug: 'whitechapel', label: 'Whitechapel' },         // 22
  { slug: 'camden', label: 'Camden' },                   // 18
  { slug: 'brixton', label: 'Brixton' },                 // 10 + GSC
];

/** Alias slug/display → nombre canónico (propertyLocation) */
const LONDON_LOCATION_ALIASES = {
  'Elephant & Castle': 'Elephant and Castle',
  'Wembley Park': 'Wembley',
  'Old Oak': 'Acton',
  'Old Street': 'Shoreditch',
  'Camden Town': 'Camden',
  'Camden Lock': 'Camden',
  'Homerton': 'Hackney',
  'Clapham South': 'Clapham',
  'Fulham Broadway': 'Fulham',
  'Hounslow Central': 'Hounslow',
  'Crossharbour': 'Canary Wharf',
};

/**
 * Grupos Firestore: clave canónica → variantes reales en propertyLocation
 * (Firestore `in` query max 10 — grupos pequeños)
 */
const LONDON_LOCATION_GROUPS = {
  'Elephant and Castle': ['Elephant and Castle', 'Elephant & Castle'],
  'Camden': ['Camden', 'Camden Town', 'Camden Lock'],
  'Clapham': ['Clapham', 'Clapham South'],
  'Hackney': ['Hackney', 'Homerton'],
  'Fulham': ['Fulham', 'Fulham Broadway'],
  'Hounslow': ['Hounslow', 'Hounslow Central'],
  'Canary Wharf': ['Canary Wharf', 'Crossharbour'],
  'Acton': ['Acton', 'Old Oak'],
  'Shoreditch': ['Shoreditch', 'Old Street'],
  'Wembley': ['Wembley', 'Wembley Park'],
};

const LONDON_AREAS_SET = new Set(LONDON_NEIGHBORHOODS);

/** Búsqueda metro "London" (slug /findyourcoliving/london) — no hay propertyLocation "London" en Firestore */
function resolveLondonMetroSearch(locationName) {
  const trimmed = (locationName || '').trim();
  if (trimmed !== 'London') return null;
  return { region: 'uk' };
}

function isLondonNeighborhood(propertyLocation) {
  if (!propertyLocation || typeof propertyLocation !== 'string') return false;
  const trimmed = propertyLocation.trim();
  const canonical = LONDON_LOCATION_ALIASES[trimmed] || trimmed;
  return LONDON_AREAS_SET.has(canonical);
}

module.exports = {
  LONDON_NEIGHBORHOODS,
  QUICK_LONDON_AREAS,
  LONDON_LOCATION_ALIASES,
  LONDON_LOCATION_GROUPS,
  LONDON_AREAS_SET,
  resolveLondonMetroSearch,
  isLondonNeighborhood,
};
